import Axios from 'axios'
import { Notification, MessageBox, Message } from 'element-ui'
import errorCode from '@/utils/errorCode'
import {getToken, removeEnterprise, removeToken, removeUser} from '@/utils/auth'

const production = 'https://www.lingqitong.cn/stage-api'// 生产
const development = 'https://www.lingqitong.cn/stage-api'// 本地
// const development = 'http://192.168.110.11:18080'// 本地

Axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? development : production

// 是否显示重新登录
export let isRelogin = { show: false }

Axios.interceptors.request.use(config => {
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false

    if (getToken() && !isToken) {
        config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }

    return config
}, error => {
    return Promise.reject(new Error(error))
})
Axios.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
        return res.data
    }
    if (code === 401) {
        removeToken()
        if (!isRelogin.show) {
            isRelogin.show = true
            MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
                isRelogin.show = false
                removeUser()
                removeEnterprise()
                location.href = '/loginRegister'
            }).catch(() => {
                isRelogin.show = false
            })
        }
        return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
        Message({ message: msg, type: 'error' })
        return Promise.reject(new Error(msg))
    } else if (code === 601) {
        Message({ message: msg, type: 'warning' })
        return Promise.reject('error')
    } else if (code !== 200) {
        Notification.error({ title: msg })
        return Promise.reject('error')
    } else {
        return res.data
    }
}, error => {
    let { message } = error
    if (message == "Network Error") {
        message = "后端接口连接异常"
    } else if (message.includes("timeout")) {
        message = "系统接口请求超时"
    } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.slice(-3) + "异常"
    }
    Message({ message: message, type: 'error', duration: 5 * 1000 })
    return Promise.reject(error)
})

export default Axios
